import React, { useState, useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { userBranchesAtom } from '../../../Atoms';
import useTranslate from '../../../Hooks/useTranslate';
import FiltersNavbarWrapper from '../../../Components/Filters/FiltersNavbarWrapper';
import { FullSizeCenteredFlexBox } from '../../../Components/FlexBox';
import ReportSelect from '../../../Components/Inputs/ReportSelect';
import { Button } from '@mui/material';
import capitalize from '../../../Helpers/StringsFormatting/capitalize';
import { culture } from '../../../Helpers/dates';

const getLastYearMonths = () => {
  const months = [];
  const currentDate = new Date();
  for (let i = 0; i < 12; i++) {
    const month = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - i,
      1
    );
    months.push({
      label: capitalize(
        month.toLocaleString(culture, {
          month: 'long',
          year: 'numeric',
        })
      ),
      value:
        month.getFullYear() +
        (month.getMonth() + 1).toString().padStart(2, '0'),
      active: true,
    });
  }
  return months;
};

const FiltrersNavbar = function FiltersNavbar({
  currentFilters,
  setCurrentFilters = () => {},
  open = true,
  toggle = () => {},
  isOperator = false,
  title = '',
  switchLabel = '',
  onSwitchClick = undefined,
  switchValue = false,
}) {
  const translate = useTranslate();
  const userBranches = useAtomValue(userBranchesAtom);
  const [branchId, setBranchId] = useState(currentFilters?.branchId || '');
  const [wavePeriod, setWavePeriod] = useState(
    currentFilters?.wavePeriod || ''
  );

  useEffect(() => {
    if (!currentFilters) return;

    setBranchId(currentFilters.branchId || '');
    setWavePeriod(currentFilters.wavePeriod || '');
  }, [currentFilters]);

  const handleSearchClick = () => {
    setCurrentFilters({
      branchId: branchId,
      wavePeriod,
    });
  };

  return (
    <FiltersNavbarWrapper
      open={open}
      title={title}
      onToggle={toggle}
      currentFilters={currentFilters}
      setCurrentFilters={setCurrentFilters}
      switchLabel={switchLabel}
      onSwitchClick={onSwitchClick}
      switchValue={switchValue}
      isOperator={isOperator}
    >
      <FullSizeCenteredFlexBox gap="24px">
        <ReportSelect
          value={branchId}
          onChange={(e) => setBranchId(e.target.value)}
          classes={{
            selectLabel: {
              borderRight: '1px solid',
              borderColor: (theme) => theme.palette.divider,
            },
          }}
          fullWidth
          height="30px"
          padding="20px"
          label={translate('BRANCH')}
          items={[
            {
              value: '',
              label: translate('ALL'),
              active: true,
            },
            ...userBranches.map(({ id, branchDescription }) => ({
              value: id,
              label: branchDescription,
              active: true,
            })),
          ]}
        />
        <ReportSelect
          value={wavePeriod}
          onChange={(e) => setWavePeriod(e.target.value)}
          classes={{
            selectLabel: {
              borderRight: '1px solid',
              borderColor: (theme) => theme.palette.divider,
            },
          }}
          fullWidth
          height="30px"
          padding="20px"
          label={translate('PERIOD')}
          items={getLastYearMonths()}
        />

        <Button
          id="search-btn"
          onClick={handleSearchClick}
          variant="contained"
          color="primary"
          size="large"
          sx={{ width: '160px' }}
        >
          {translate('SEARCH')}
        </Button>
      </FullSizeCenteredFlexBox>
    </FiltersNavbarWrapper>
  );
};

export default FiltrersNavbar;
